import Component from '../abstracts/Component';

export default class ListingShortcutsComponent extends Component {
  get COMPONENTNAME() {
    return 'ListingShortcutsComponent';
  }

  get SELECTORS() {
    return {
      carousel: '[data-slick-carousel]:not(.slick-initialized)',
      prevArrow: '[data-prev-arrow]',
      nextArrow: '[data-next-arrow]',
      slide: '[data-slide]',
      firstShortcut: '#shortcut_0',
      breadcrumbsWrapper: '[data-js-breadcrumb]',
      pageSize: '[data-page-size]',
      filtersComponent: '[data-js-component="FiltersComponent"]',
      infiniteScrollBtn: '.js-infinite-scroll',
    };
  }

  get QUERY_PARAMS() {
    return {
      base: '?save=false&q=:topRated',
      end: ':sortBy:topRated&size=',
    };
  }

  get CLASSNAMES() {
    return {
      slickActive: 'slick-active',
      selected: 'selected',
    };
  }

  constructor(elem) {
    super(elem);
    this.filterComponentEl = null;
    this.filterComponent = null;
    this.breadcrumbsWrapper = document.querySelector(this.SELECTORS.breadcrumbsWrapper);
    this.infiniteScrollBtn = document.querySelector(this.SELECTORS.infiniteScrollBtn);
    this.pageSize = document.querySelector(this.SELECTORS.pageSize);
    this.slidesToShowDesktop = 6;
    this.slickSlider = null; //will store slick slider instance
  }

  readDOM() {
    return {
      carousel: this.$component.querySelector(this.SELECTORS.carousel),
      prevArrow: this.$component.querySelector(this.SELECTORS.prevArrow),
      nextArrow: this.$component.querySelector(this.SELECTORS.nextArrow),
      slides: [...this.$component.querySelectorAll(this.SELECTORS.slide)],
      firstShortcut: this.$component.querySelector(this.SELECTORS.firstShortcut),
    };
  }

  bindEvents() {
    this.dom.slides.forEach((item, index, allSlidesArr) => {
      item.addEventListener('click', () => {
        let shortcutBreadcrumbTitle = '';
        let query = '';
        const itemPreviouslySelected = item.classList.contains(this.CLASSNAMES.selected);
        const isFirstShortcut = index === 0;
        //exit when click on first shortcut & was already selected
        if (isFirstShortcut && itemPreviouslySelected) return;

        const firstShortcutEl = allSlidesArr[0];
        const itemSelected = item.classList.toggle(this.CLASSNAMES.selected, !itemPreviouslySelected);
        //unselect other items
        this.dom.slides.forEach(otherEl => {
          if (otherEl.id !== item.id) {
            otherEl.classList.toggle(this.CLASSNAMES.selected, false);
          }
        });
        //selected state at first shortcut when unselect other items
        if (!isFirstShortcut) {
          firstShortcutEl.classList.toggle( this.CLASSNAMES.selected, !itemSelected );
        }
        //sku list populated
        if (item.dataset.products && itemSelected) {
          let productsArray = item.dataset.products.split(',');
          query = this.QUERY_PARAMS.base;
          shortcutBreadcrumbTitle = item.dataset.shortcutTitle ? item.dataset.shortcutTitle : '';

          productsArray.forEach(productCode => {
            if (productCode.length == 13) {
              query += ':codeFilter:' + productCode;
            }
          });
          query += this.QUERY_PARAMS.end + '-1';
          this.log('fullQuery ', query);
        }

        // launch the query
        this.launchQuery( query);
        this.setShortcutBreadcrumb(shortcutBreadcrumbTitle);
        // toggle filters visibility
        this.toggleFiltersVisibility(isFirstShortcut,query);
        //
        const toggleLoadMoreBtnCondition = !isFirstShortcut || query.includes('codeFilter');
        this.hideLoadMoreBtn(toggleLoadMoreBtnCondition);
      });
    });
  }

  launchQuery(query) {
    // if not set, let's kick-in
    if (typeof this.filterComponent === 'undefined') {
      this.setFiltersComponentInstance();
    }
    this.filterComponent.filterQuery(false, false, query);
  }

  toggleFiltersVisibility(isFirstShortcut,query) {
    // if not set, let's kick-in
    if (this.filterComponent === 'undefined') {
      this.setFiltersComponentInstance();
    }
    const toggleFiltersCondition = isFirstShortcut || !query.includes('codeFilter');
    this.toggleFilters(toggleFiltersCondition);
  }

  setFiltersComponentInstance() {
    // console.log('Check FiltersComponent instance from ListingShortcutsComponent');
    //check if filters component DOM element exist
    this.filterComponentEl = document.querySelector(this.SELECTORS.filtersComponent);
    //get FiltersComponent instance from DOM element
    this.filterComponent = this.filterComponentEl ? this.filterComponentEl.component : null;
  }

  slickEvents() {
    const isTabletDesktop = () => this.mediaMatch([992, 999999]);
    //registering slick events
    $(this.dom.carousel).on('init', (ev, slick) => {
      this.$component.classList.add('--slick-loaded');
      if (isTabletDesktop()) {
        this.renderCarouselWidth(this.dom, slick.$slides);
      }
    });
    $(this.dom.carousel).on('beforeChange', (ev, slick, currentSlide, nextSlide) => {
        if (isTabletDesktop()) {
          this.renderCarouselWidth(this.dom, slick.$slides, currentSlide, nextSlide);
        }
      }
    );
  }

  initSlider() {
    //registering slick events before instance
    this.slickEvents();
    let opts = {
      slidesToShow: this.slidesToShowDesktop,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      variableWidth: true,
      infinite: false,
      prevArrow: this.dom.prevArrow,
      nextArrow: this.dom.nextArrow,
      rows: 0,
      draggable: true,
      centerMode: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            swipe: true,
            swipeToSlide: true,
            arrows: false,
          },
        },
      ],
    };

    this.slickSlider = $(this.dom.carousel).slick(opts);
  }

  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        this.initSlider();
      },
      error => {
        console.error(
          'failed to load slick into ListingShortcutsComponent ',
          error.stack
        );
      }
    );
  }

  hideLoadMoreBtn(isHidden) {
      this.infiniteScrollBtn.style.visibility = isHidden ? 'hidden' : 'visible';
  }

  checkCategory() {
    const searchParams = window.location.search;
    if (!searchParams) return;
    const params = new URLSearchParams(searchParams);
    const queryParam = params.get('q');
    const regex = /codeFilter:\d+/g;
    const codeFiltersFromQuery = queryParam.match(regex);
    if (!codeFiltersFromQuery) return;
    this.hideLoadMoreBtn(true);
    const productsFromQuery = codeFiltersFromQuery.map(code => {
      return code.split(':')[1];
    });
    this.dom.slides.forEach(item => {
      let isCurrent = false;
      const itemProducts = item.dataset.products ? item.dataset.products.split(',') : [];
      const hasSameProductsLength =
        itemProducts.length === productsFromQuery.length;
      if (hasSameProductsLength) {
        isCurrent = itemProducts.every(product => {
          return productsFromQuery.includes(product);
        });
      }
      item.classList.toggle(this.CLASSNAMES.selected, isCurrent);
    });
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    this.setFiltersComponentInstance();
    this.checkCategory();
    this.importSlick();
    this.bindEvents();
  }

  mediaMatch(interval) {
    const [minpx, maxpx] = interval;
    return window.matchMedia(
      `screen and (min-width: ${minpx}px) and (max-width: ${maxpx}px)`
    ).matches;
  }

  renderCarouselWidth(dom, slides, curr = 0, next = 0) {
    let carouselWidth = 0;
    let slidesToShow = this.slidesToShowDesktop;
    if (curr < next) {
      for (let cssClass of slides) {
        if (
          cssClass.dataset.slickIndex > curr &&
          cssClass.dataset.slickIndex <= this.toNumber(slidesToShow, 0) + curr
        ) {
          carouselWidth += cssClass.offsetWidth;
        }
      }
    } else if (curr > next) {
      for (let cssClass of slides) {
        if (
          cssClass.dataset.slickIndex >= next &&
          cssClass.dataset.slickIndex < this.toNumber(slidesToShow, 0) + next
        ) {
          carouselWidth += cssClass.offsetWidth;
        }
      }
    } else {
      for (let cssClass of slides) {
        if (cssClass.classList.contains(this.CLASSNAMES.slickActive)) {
          carouselWidth += cssClass.offsetWidth;
        }
      }
    }
    dom.carousel.style.width = carouselWidth + 'px';
    dom.carousel.style.maxWidth = '100%';
  }

  toNumber(str, def) {
    return str !== undefined ? Number(str) : def;
  }

  setShortcutBreadcrumb(title) {
    const hasTitle = title && typeof title === 'string' && title.length > 0;
    let a = this.breadcrumbsWrapper.querySelector('a.shortcut-page');
    a.innerText = hasTitle ? title : '';
    a.classList.toggle('last', hasTitle);
    this.breadcrumbsWrapper
      .querySelector('.js-last')
      .classList.toggle('last', !hasTitle);
    this.breadcrumbsWrapper.querySelectorAll('.shortcut-page').forEach(el => {
      el.style.display = hasTitle ? 'inline-block' : 'none';
    });
  }

  toggleFilters(isVisible = true) {
    let filters = this.filterComponent.filters;
    let mobileFiltersCta = this.filterComponent.triggerMenu;
    let resetCta = this.filterComponent.resetCta;

    if (filters && filters.length > 0) {
      filters.forEach(item => {
        item.style.visibility = isVisible ? 'visible' : 'hidden';
      });
    }
    if (mobileFiltersCta != null){
      mobileFiltersCta.style.visibility = isVisible ? 'visible' : 'hidden';
    }
    if (resetCta && resetCta.length > 0) {
      resetCta.forEach(item => {
        item.style.visibility = isVisible ? 'visible' : 'hidden';
      });
    }
  }

}
